export { CorporativoCardRegional } from "./CorporativoCardRegional";
